import {convertCoordinates} from '@/api/util-coordinates';

class WayStJamesApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    name,
    province,
    length,
    lengthStr,
    cx,
    cy,
    // visible,
  }) {
    return {
      id,
      name,
      province,
      length,
      lengthStr,
      coordinates: convertCoordinates(cx, cy),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default WayStJamesApiResponseModel;
